import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Bell, BellOff } from 'lucide-react';
import { useState } from 'react';

interface Props {
  shouldShow: boolean;
  title: string;
  body: string;
  ctaLabel?: string;
  onAllow: () => Promise<void> | void;
  onDismiss: () => Promise<void> | void;
}

export function PermissionPromptModal({ shouldShow, title, body, ctaLabel = 'Allow notifications', onAllow, onDismiss }: Props) {
  const [busy, setBusy] = useState(false);

  const handleAllow = async () => {
    setBusy(true);
    try { await onAllow(); } finally { setBusy(false); }
  };
  const handleDismiss = async () => {
    setBusy(true);
    try { await onDismiss(); } finally { setBusy(false); }
  };

  return (
    <Dialog open={shouldShow} onOpenChange={(v) => { if (!v) handleDismiss(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto h-14 w-14 rounded-full bg-primary/10 flex items-center justify-center mb-2">
            <Bell className="h-7 w-7 text-primary" />
          </div>
          <DialogTitle className="text-center text-xl">{title}</DialogTitle>
          <DialogDescription className="text-center">{body}</DialogDescription>
        </DialogHeader>
        <div className="rounded-lg border bg-muted/30 p-3 text-xs text-muted-foreground">
          <p className="flex items-start gap-2">
            <span className="text-primary">✓</span>
            <span>You can change this anytime in Settings → Notifications.</span>
          </p>
        </div>
        <DialogFooter className="flex-col sm:flex-col gap-2 sm:gap-2">
          <Button onClick={handleAllow} disabled={busy} className="w-full" size="lg">
            {busy ? 'Enabling…' : ctaLabel}
          </Button>
          <Button variant="ghost" onClick={handleDismiss} disabled={busy} className="w-full">
            <BellOff className="h-4 w-4 mr-1.5" /> Maybe later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
